import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #0a1628 0%, #0f2035 50%, #1a1a2e 100%)',
      padding: '20px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    }}>
      <div style={{ textAlign: 'center', maxWidth: '480px' }}>
        <h1 style={{
          fontSize: '120px',
          fontWeight: 800,
          color: '#c5a47e',
          lineHeight: 1,
          marginBottom: '8px',
        }}>
          404
        </h1>
        <h2 style={{
          fontSize: '28px',
          fontWeight: 700,
          color: '#fff',
          marginBottom: '16px',
        }}>
          Page Not Found
        </h2>
        <p style={{
          fontSize: '16px',
          color: '#94a3b8',
          lineHeight: 1.6,
          marginBottom: '36px',
        }}>
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link
          to="/"
          style={{
            display: 'inline-block',
            padding: '14px 36px',
            background: '#c5a47e',
            color: '#fff',
            borderRadius: '10px',
            fontSize: '14px',
            fontWeight: 600,
            letterSpacing: '1px',
            textTransform: 'uppercase',
            textDecoration: 'none',
          }}
        >
          Go Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
